// extracted by mini-css-extract-plugin
module.exports = {"container":"outline-gray-button_container__3-skK","button":"outline-gray-button_button__Yjt3o"};